import { PurchaseData } from '@lib/types';
import { Dispatch, SetStateAction, useState } from 'react';
import styles from './styles.module.scss';
import NumInput from '@components/FormComponents/NumInput';

const GiftCardSelection = ({
    purchaseDataAmount,
    setPurchaseData,
}: {
    purchaseDataAmount: number;
    setPurchaseData: Dispatch<SetStateAction<PurchaseData>>;
}) => {
    const predefinedAmounts = [20, 50, 100, 300, 500, 1000];
    const [customAmount, setCustomAmount] = useState<string>('');

    // Handle selection of predefined amounts
    const handleAmountSelect = (amount: number) => {
        setPurchaseData((prevData) => ({
            ...prevData,
            amount,
        }));
        setCustomAmount(''); // Clear NumInput value
    };

    // Handle changes in the NumInput for custom amounts
    const handleCustomAmountChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setCustomAmount(e.target.value);
        setPurchaseData((prevData) => ({
            ...prevData,
            amount: Number(e.target.value),
        }));
    };

    return (
        <div>
            <div className={styles.gridContainer}>
                {predefinedAmounts.map((amount) => (
                    <button
                        key={amount}
                        onClick={() => handleAmountSelect(amount)}
                        className={`
                            ${styles.button}
                            ${purchaseDataAmount === amount ? styles.selected : ''}
                        `}
                    >
                        ${amount}
                    </button>
                ))}
            </div>
            <div className={styles.customAmountContainer}>
                <NumInput
                    id="customAmount"
                    name="customAmount"
                    title="Custom Amount"
                    placeholder="Enter custom amount"
                    min="0"
                    max="2500"
                    value={customAmount}
                    onChange={handleCustomAmountChange}
                />
                <label className={styles.tooltip}>
                    (Minimum $20 - Maximum $2,500)
                </label>
            </div>
        </div>
    );
};

export default GiftCardSelection;